import React from 'react'

import PropTypes from 'prop-types'
import { SitePhone } from 'common/sitePhone'
import styles from './callToBookForm.module.scss'
import { useGTM } from 'app/GTM'

const CallToBookForm = ({ className = '', ...rest }) => {
  const GTM = useGTM()

  const trackPhoneClick = () => {
    GTM.trackEvent('CallToBookModal_PhoneClicked')
  }

  return (
    <div className={`${styles.callToBookForm} ${className}`} {...rest}>
      <div className={`${styles.callToBookForm__text}`}>
        Call now and receive up to
        <span> $25 off our fees</span>
      </div>
      <SitePhone className={styles.callToBookForm__submit} onClick={trackPhoneClick} />
    </div>
  )
}

CallToBookForm.propTypes = {
  className: PropTypes.string,
  onSubmitOk: PropTypes.func,
}

export { CallToBookForm }
